const API_URL = process.env.REACT_APP_API_URL || 'https://geroiyar.yarcloud.ru';

export const SovetService = {
  
  async fetchSovet() {
    try {
      const response = await fetch(API_URL+'/api/sovets/?populate=foto');
      if (!response.ok) throw new Error('Ошибка загрузки совета');
      const { data } = await response.json();
 
      return data.map((item) => ({
        id: String(item.documentId),
        fio: item.fio,
        description: item.description,
        foto: item.foto?.url 
          ? API_URL+`${item.foto.url}`
          : null
      }));
    } catch (error) {
      throw new Error('Не удалось загрузить совет: ' + error.message);
    }
  }
}